import { render, staticRenderFns } from "./settlements-tab.vue?vue&type=template&id=58e89f60&scoped=true&"
import script from "./settlements-tab.vue?vue&type=script&lang=js&"
export * from "./settlements-tab.vue?vue&type=script&lang=js&"
import style0 from "./settlements-tab.vue?vue&type=style&index=0&id=58e89f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e89f60",
  null
  
)

export default component.exports